import { NgModule } from '@angular/core';
import {FulltextSearchPipe} from "./fulltext-search-pipe";

@NgModule({
  declarations: [FulltextSearchPipe],
  imports: [
  ],
  exports: [FulltextSearchPipe]
})
export class FulltextSearchPipeModule { }
